import { Accordion, AccordionSummary, Dialog, IconButton, Stack, Typography, useTheme } from '@mui/material';
import React, { useRef } from 'react';
import AccessPermissionCard from './AccessPermissionCard';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from 'react';
import { useEffect } from 'react';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import ClearIcon from '@mui/icons-material/Clear';

export default function RolePrivilageDialog({ open, handleClose, roleId }) {
  const theme = useTheme();
  const formRef = useRef();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const [expanded, setExpanded] = useState(false);
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(false);

  let source = CancelToken.source();

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const sx = {
    '& .MuiDialog-container': {
      alignItems: 'center',
    },
    '& .MuiPaper-root': {
      borderRadius: '4px',
      width: '500px',
    },
  };

  useEffect(() => {
    if (roleId) {
      getUserDetails();
    } else {
      setUserData(null);
    }
  }, [roleId]);

  const getUserDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(`user-management/role/${roleId}`);
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setUserData(data.response);
      }
      setLoading(false);
    }
  };

  return (
    <Dialog
      sx={sx}
      open={open}
      onClose={handleClose}
      // TransitionComponent={Transition}
      //   className="AddUserContainer"
    >
      <div width={{}}>
        <Stack
          className="pt-[10px] px-[16px] pb-[24px]"
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
        >
          <Stack>
            <Typography
              className="fs-16 ff-Roboto fw-regular"
              color={text}
            >
              Permissions
            </Typography>
            <Typography
              className="fs-12 ff-Roboto fw-regular"
              color={textLight}
            >
              {roleId === '651528ba1d7810871a8eac38' ? 'Admin' : 'Standard'}
            </Typography>
          </Stack>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
          </IconButton>
        </Stack>
        <Accordion
          expanded={expanded === 'panel1'}
          onChange={handleChange('panel1')}
          style={{ margin: '0px' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{ width: '33%', flexShrink: 0 }}
              className="fs-14 ff-Roboto fw-medium"
              color={text}
            >
              Fleet Management
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ padding: '0px' }}>{userData && <AccessPermissionCard permission={userData[0]} />}</AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel2'}
          onChange={handleChange('panel2')}
          style={{ margin: '0px' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{ width: '33%', flexShrink: 0 }}
              className="fs-14 ff-Roboto fw-medium"
              color={text}
            >
              User Management
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ padding: '0px' }}>{userData && <AccessPermissionCard permission={userData[1]} />}</AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel3'}
          onChange={handleChange('panel3')}
          style={{ margin: '0px' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{ width: '40%', flexShrink: 0 }}
              className="fs-14 ff-Roboto fw-medium"
              color={text}
            >
              Contact Management
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ padding: '0px' }}>{userData && <AccessPermissionCard permission={userData[2]} />}</AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel4'}
          onChange={handleChange('panel4')}
          style={{ margin: '0px' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{ width: '40%', flexShrink: 0 }}
              className="fs-14 ff-Roboto fw-medium"
              color={text}
            >
              Dashboard
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ padding: '0px' }}>{userData && <AccessPermissionCard permission={userData[3]} />}</AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel5'}
          onChange={handleChange('panel5')}
          style={{ margin: '0px' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{ width: '40%', flexShrink: 0 }}
              className="fs-14 ff-Roboto fw-medium"
              color={text}
            >
              Credit Management
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ padding: '0px' }}>{userData && <AccessPermissionCard permission={userData[4]} />}</AccordionDetails>
        </Accordion>
        <Accordion
          expanded={expanded === 'panel6'}
          onChange={handleChange('panel6')}
          style={{ margin: '0px' }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography
              sx={{ width: '40%', flexShrink: 0 }}
              className="fs-14 ff-Roboto fw-medium"
              color={text}
            >
              Organization Settings
            </Typography>
          </AccordionSummary>
          <AccordionDetails style={{ padding: '0px' }}>{userData && <AccessPermissionCard permission={userData[3]} />}</AccordionDetails>
        </Accordion>
      </div>
    </Dialog>
  );
}
